<template>
  <v-row class="justify-center" transition="slide-x-transition">
    <v-col cols="12" sm="12" md="10" lg="8" class="d-flex align-stretch pa-1">
      <v-card class="flex-grow-1">
        <v-toolbar color="grey lighten-4" elevation="0" light dense>
          <v-toolbar-title>2ª via de boletos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$router.go(-1)">
            <v-icon>fa-solid fa-reply</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-subtitle class="text-left primary--text">
          <v-row class="pa-2" transition="slide-x-transition">
            <v-col cols="12" sm="12" md="8" lg="9" class="d-flex pa-1">
              <p v-if="allBankSlip.length > 0" class="mt-4">
                <v-icon color="primary">fa-solid fa-triangle-exclamation</v-icon>
                {{ message }}
              </p>
              <p v-if="allBankSlip.length == 0" class="grey--text text--darken-1 mt-4 text-center">{{ message }}</p>
            </v-col>
            <v-col cols="12" sm="12" md="4" lg="3" class="d-flex pa-1">
              <v-spacer></v-spacer>
              <v-form ref="formSearchBankSlip" lazy-validation v-if="!userBankslip">
                <v-text-field v-model="cpf" :rules="formRules.cpfRules" label="CPF"
                  append-outer-icon="fa-solid fa-magnifying-glass" v-mask="mask"
                  v-on:keydown.enter.prevent="getBankSlipsByCPF()"
                  @click:append-outer="getBankSlipsByCPF()"></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-card-subtitle>
        <v-card-text class="text--primary mb-2 justify-center">
          <v-data-table :headers="headers" :items="allBankSlip" class="elevation-1" hide-default-footer
            v-if="allBankSlip.length">
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.codigo">
                  <td class="text-left">{{ item.dataVencimento }}</td>
                  <td class="text-left">{{ item.valorDocumento | formatPrice }}</td>
                  <td class="text-left">{{ item.codigo }}</td>
                  <td class="text-left" v-if="item.linhaDigitavel != ''">
                    <v-text-field :id="`ipt_${item.codigo}`" v-model="item.linhaDigitavel" label
                      append-outer-icon="fa-regular fa-copy" @click:append-outer="copyBarcode(item.codigo)"
                      @focus="copyBarcode(item.codigo)" hint="Linha digitável copiada para o clipboard"></v-text-field>
                  </td>
                  <td class="text-left" v-else>
                    <p class="pt-3 pb-0"><span class="primary--text">Boleto {{ item.mensagem }}!</span><br>
                      Prezado Cliente, entre em contato devido ao prazo de vencimento do boleto.</p>
                  </td>
                  <td class="text-left">
                    <v-btn :disabled="item.linhaDigitavel == ''" text icon color="secondary darken-4"
                      @click="getUrlOpenBilet(cpf, item.codigo)">
                      <!-- :href="'http://www.corporeadministradora.com.br/boletos/?cpf='+cpf+'&idBillet='+item.codigo+'&ey='+$store.state.ey" -->
                      <v-icon>fa-solid fa-barcode</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
        <!-- Botão para redirecionar para site de pagamento -->
        <v-card-actions v-if="allBankSlip.length" class="mb-2 justify-center px-4 pb-6">
          <v-btn class="white--text text-none py-2" color="error darken-1" href="https://corpe.portal.7az.com.br/login"
            target="_blank" rel="noopener noreferrer" style="width: 50%; height: auto; white-space: normal;">
            Clique aqui e pague via pix ou cartão de crédito
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
import { mask } from "vue-the-mask";

export default {
  directives: {
    mask
  },
  data() {
    return {
      allBankSlip: [],
      cpf: null,
      hasDebit: false,
      mask: "###.###.###-##",
      message: "",
      search: "",
      userBankslip: false
    };
  },
  mounted() {
    if (this.userBankslip) {
      this.getBankslipsOpened();
    }
  },
  watch: {
    plans: {
      immediate: true,
      handler(cpf) {
        if (cpf.length) {
          this.cpf = localStorage.corporeUserId;
          this.showAlertPayment();
          this.getBankSlipsByCPF();
          this.userBankslip = true;
        } else {
          this.userBankslip = false;
        }
      }
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
    plans() {
      return this.$store.state.plans.plans;
    },
    headers() {
      return this.$store.state.bankSlip.headers;
    },
    selected: {
      get() {
        return this.$store.state.bankSlip.selected;
      },
      set(val) {
        this.$store.commit("bankSlip/setSelected", val);
      }
    },
    userName() {
      return this.$store.state.plans.userName;
    }
  },
  methods: {
    getUrlOpenBilet(cpf, doc) {
      let obj = {
        url: "/boletos",
        query: { cpf: cpf, codigocobranca: doc },
        method: "post",
      };
      // console.log("sssss");
      this.$store.dispatch("request/doRequest", obj).then((resp) => {
        //console.log(resp);
        if (!resp) {
          return;
        }
        window.open(resp.data.link, '_blank');
      });
    },
    async getBankslipsOpened() {
      await this.$store
        .dispatch("bankSlip/getBankSlipsByCPF", this.cpf)
        .then(resp => {
          //var overdueList = resp.filter(bankSlip => this.verifyOverdue(bankSlip))
          //this.hasDebit = overdueList.length > 0
          //( overdueList.length > 0 ?  `${resp[0].nomeTitular}, você possui boletos vencidos.` : )
          this.message = resp.length
            ? `${resp[0].nomeTitular}, você possui boletos em aberto.`
            : `Não foram encontrados boletos vencidos para este CPF!`
          if (resp.quantidade == 0) {
            this.message = "Não foram encontrados planos para este CPF"
          }
          this.allBankSlip = resp;
        });
      return this.allBankSlip;
    },
    verifyOverdue(bankSlip) {
      var [day, month, year] = bankSlip.dataVencimento.split('/')
      return new Date([month, day, year]).getTime() < new Date().getTime()
    },
    copyBarcode(id) {
      var ipt = `ipt_${id}`;
      var copyText = document.getElementById(ipt);
      copyText.select();
      document.execCommand("copy");

      return;
    },
    async getBankSlipsByCPF() {
      if (
        this.$refs.formSearchBankSlip &&
        this.$refs.formSearchBankSlip.validate()
      ) {
        await this.$store
          .dispatch("bankSlip/getBankSlipsByCPF", this.cpf)
          .then(resp => {
            this.message = resp.length
              ? `${resp[0].nomeTitular}, você possui boletos em aberto.`
              : `Não foram encontrados boletos vencidos para este CPF!`
            this.allBankSlip = resp;
          });
        return this.allBankSlip;
      }
    },
    showAlertPayment() {
      let isToShow = this.$store.dispatch(
        "bankSlip/showAlertPayment",
        this.plans
      );
      return isToShow;
    }
  }
};
</script>
